<div class="max-w-4xl mx-auto px-4 py-12">
  <div class="prose max-w-none">
    <h1 class="text-4xl font-bold mb-6">Termos de Uso</h1>

    <p class="text-gray-600 mb-8">
      <strong>Data de Atualização:</strong> {{ currentYear }}<br>
      <strong>Última Revisão:</strong> {{ currentYear }}
    </p>

    <div class="border border-gray-200 rounded-xl p-6 mb-10 bg-white shadow-sm">
      <h2 class="text-xl font-semibold mb-4">Sumário</h2>
      <div class="toc-grid grid gap-2 sm:grid-cols-2">
        <a class="text-blue-700 hover:text-blue-900 transition" href="#aceitacao">1. Aceitação dos Termos</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#descricao">2. Descrição da Plataforma</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#elegibilidade">3. Elegibilidade e Cadastro</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#direitos">4. Direitos e Responsabilidades</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#propriedade">5. Propriedade Intelectual</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#inscricoes">6. Inscrições em Concursos</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#tarifas">7. Tarifas e Pagamentos</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#resultados">8. Resultados e Avaliação</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#limitacao">9. Limitação de Responsabilidade</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#interrupcao">10. Interrupção de Serviço</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#modificacao">11. Modificação dos Termos</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#rescisao">12. Rescisão da Conta</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#lei">13. Lei Aplicável e Jurisdição</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#severabilidade">14. Severabilidade</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#contato">15. Contato e Suporte</a>
      </div>
    </div>

    <section id="aceitacao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">1. Aceitação dos Termos</h2>
      <p class="mb-4">
        Ao acessar e utilizar esta plataforma de concursos públicos ("Plataforma"), você concorda em aceitar
        e cumprir todos os termos e condições estabelecidos neste documento. Se você não concordar com qualquer
        parte destes termos, favor não utilizá-la. O acesso continuado à Plataforma após a publicação de qualquer
        modificação constitui sua aceitação dos termos modificados.
      </p>
    </section>

    <section id="descricao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">2. Descrição da Plataforma</h2>
      <p class="mb-4">
        A Plataforma é um sistema eletrônico de gestão de concursos públicos que fornece informações sobre editais,
        permite inscrições de candidatos, gerenciamento de documentação, visualização de resultados e comunicação
        entre candidatos e organizadores de concursos. A plataforma opera através de tecnologias web modernas e é
        acessível via navegador de internet.
      </p>
    </section>

    <section id="elegibilidade" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">3. Elegibilidade e Cadastro</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.1 Requisitos de Idade</h3>
        <p class="mb-4">
          Você deve ter pelo menos 18 (dezoito) anos de idade para utilizar esta Plataforma. Se você for menor de idade,
          deverá contar com autorização e supervisão de um responsável legal. Qualquer uso por pessoa menor de idade sem
          autorização apropriada é responsabilidade exclusiva do usuário e de seus responsáveis legais.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.2 Informações de Cadastro</h3>
        <p class="mb-4">
          Ao criar uma conta, você concorda em fornecer informações precisas, atualizadas e completas. Você é responsável
          por manter a confidencialidade de suas credenciais de login e por todas as atividades que ocorram em sua conta.
          Você concorda em notificar imediatamente o suporte da Plataforma sobre qualquer uso não autorizado de sua conta.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.3 Identidade Verificada</h3>
        <p class="mb-4">
          A Plataforma pode realizar verificações de identidade conforme necessário. Você concorda em participar de
          qualquer verificação de identidade solicitada e em fornecer documentação adequada que comprove sua identidade.
        </p>
      </div>
    </section>

    <section id="direitos" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">4. Direitos e Responsabilidades do Usuário</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">4.1 Uso Permitido</h3>
        <p class="mb-4">
          Você concorda em utilizar a Plataforma apenas para propósitos legais e autorizados. Especificamente, você se
          compromete a:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Usar a Plataforma em conformidade com todas as leis e regulamentações aplicáveis</li>
          <li>Não fornecer informações falsas, enganosas ou incompletas</li>
          <li>Não tentar contornar medidas de segurança</li>
          <li>Não violar direitos de propriedade intelectual de terceiros</li>
          <li>Não prejudicar a performance ou segurança da Plataforma</li>
          <li>Não transmitir conteúdo ilegal, ofensivo ou prejudicial</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">4.2 Uso Proibido</h3>
        <p class="mb-4">
          É expressamente proibido:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Utilizar a Plataforma para praticar fraude ou enganar outras pessoas</li>
          <li>Transmitir vírus, malware ou qualquer código malicioso</li>
          <li>Fazer sondagem, raspagem ou extração de dados automatizada</li>
          <li>Acessar ou tentar acessar áreas restritas sem autorização</li>
          <li>Criar múltiplas contas para contornar limitações</li>
          <li>Assediar, ameaçar ou prejudicar outros usuários</li>
          <li>Interferir ou prejudicar o funcionamento da Plataforma</li>
        </ul>
      </div>
    </section>

    <section id="propriedade" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">5. Propriedade Intelectual</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">5.1 Direitos da Plataforma</h3>
        <p class="mb-4">
          Todo o conteúdo presente na Plataforma, incluindo textos, gráficos, logotipos, imagens, clipes de áudio,
          downloads digitais e compilações de dados, é propriedade exclusiva da organizadora do concurso ou seus
          fornecedores de conteúdo e é protegido por leis de direitos autorais internacionais. Nenhuma parte do site
          pode ser reproduzida, distribuída, transmitida ou exibida em qualquer forma sem permissão prévia escrita.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">5.2 Conteúdo Gerado pelo Usuário</h3>
        <p class="mb-4">
          Qualquer conteúdo que você envie, poste ou exiba na Plataforma ("Conteúdo do Usuário") mantém sua propriedade.
          No entanto, você concede à Plataforma uma licença global, não-exclusiva, sem royalties e perpétua para usar,
          reproduzir, modificar e exibir seu Conteúdo do Usuário em conexão com o funcionamento da Plataforma.
        </p>
      </div>
    </section>

    <section id="inscricoes" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">6. Inscrições em Concursos</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">6.1 Processo de Inscrição</h3>
        <p class="mb-4">
          As inscrições em concursos são realizadas através da Plataforma seguindo o edital específico de cada concurso.
          O candidato é responsável por verificar todos os requisitos, prazos e procedimentos estabelecidos no edital
          antes de se inscrever.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">6.2 Confirmação de Inscrição</h3>
        <p class="mb-4">
          Após completar o processo de inscrição, você receberá uma confirmação. É sua responsabilidade verificar a
          confirmação e garantir que todos os dados foram cadastrados corretamente. Você deve notificar imediatamente
          o suporte em caso de erros.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">6.3 Dados e Documentação</h3>
        <p class="mb-4">
          Você concorda que todos os dados e documentos fornecidos durante a inscrição são verdadeiros e válidos.
          A falsificação de dados ou documentos resultará em desclassificação automática e poderá resultar em ações
          legais. A Plataforma se reserva o direito de solicitar verificação adicional de documentos.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">6.4 Inelegibilidade</h3>
        <p class="mb-4">
          Qualquer inscrição que viole os requisitos do edital será considerada inelegível e será rejeitada, sem direito
          a reembolso de taxa de inscrição (se aplicável).
        </p>
      </div>
    </section>

    <section id="tarifas" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">7. Tarifas e Pagamentos</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.1 Taxa de Inscrição</h3>
        <p class="mb-4">
          Alguns concursos podem exigir o pagamento de uma taxa de inscrição. A Plataforma aceitará pagamentos através
          de métodos de pagamento especificados no edital do concurso. Você é responsável por garantir que os fundos
          estejam disponíveis em sua conta para o pagamento da taxa.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.2 Reembolso</h3>
        <p class="mb-4">
          Taxas de inscrição são geralmente não-reembolsáveis, exceto conforme exigido por lei ou conforme específico
          no edital de cada concurso. Qualquer solicitação de reembolso deve ser feita dentro do prazo especificado.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.3 Responsabilidade por Erros de Pagamento</h3>
        <p class="mb-4">
          A Plataforma não é responsável por erros cometidos durante o processo de pagamento. Recomenda-se que você
          revise cuidadosamente todos os detalhes antes de confirmar o pagamento.
        </p>
      </div>
    </section>

    <section id="resultados" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">8. Resultados e Avaliação</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">8.1 Disponibilidade de Resultados</h3>
        <p class="mb-4">
          Os resultados do concurso serão disponibilizados através da Plataforma conforme cronograma estabelecido
          no edital. A data e hora de disponibilização serão informadas antecipadamente.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">8.2 Recursos e Reclamações</h3>
        <p class="mb-4">
          Se você desejar recorrer de um resultado ou apresentar uma reclamação, deverá seguir o procedimento formal
          estabelecido no edital do concurso, dentro dos prazos especificados.
        </p>
      </div>
    </section>

    <section id="limitacao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">9. Limitação de Responsabilidade</h2>
      <p class="mb-4">
        A PLATAFORMA É FORNECIDA "NO ESTADO EM QUE SE ENCONTRA" E "CONFORME DISPONÍVEL", SEM QUALQUER GARANTIA, EXPRESSA
        OU IMPLÍCITA, DE QUALQUER TIPO. EM NENHUMA CIRCUNSTÂNCIA A PLATAFORMA OU SEUS OPERADORES SERÃO RESPONSÁVEIS POR
        QUALQUER DANO INDIRETO, INCIDENTAL, ESPECIAL, CONSEQUENCIAL OU PUNITIVO, OU POR PERDA DE LUCROS, RECEITA, DADOS
        OU USO, MESMO QUE INFORMADOS SOBRE A POSSIBILIDADE DE TAIS DANOS.
      </p>
    </section>

    <section id="interrupcao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">10. Interrupção de Serviço</h2>
      <p class="mb-4">
        A Plataforma não garante acesso ininterrupto ou sem erros. A Plataforma pode sofrer interrupções programadas
        ou não programadas, manutenção ou problemas técnicos. A Plataforma não será responsável por qualquer dano,
        perda ou inconveniente causado por tais interrupções.
      </p>
    </section>

    <section id="modificacao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">11. Modificação dos Termos</h2>
      <p class="mb-4">
        A Plataforma se reserva o direito de modificar estes Termos de Uso a qualquer momento. Modificações entrarão
        em vigor após serem publicadas na Plataforma. Seu uso continuado da Plataforma após tais modificações constitui
        sua aceitação dos termos modificados.
      </p>
    </section>

    <section id="rescisao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">12. Rescisão da Conta</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">12.1 Rescisão pelo Usuário</h3>
        <p class="mb-4">
          Você pode rescindir sua conta a qualquer momento, sem questões, entrando em contato com o suporte da Plataforma.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">12.2 Rescisão pela Plataforma</h3>
        <p class="mb-4">
          A Plataforma pode rescindir ou suspender sua conta imediatamente, sem aviso prévio, se você violar qualquer
          disposição destes Termos de Uso ou se considerar que suas ações prejudicam a Plataforma ou outros usuários.
        </p>
      </div>
    </section>

    <section id="lei" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">13. Lei Aplicável e Jurisdição</h2>
      <p class="mb-4">
        Estes Termos de Uso serão regidos pelas leis da República Federativa do Brasil, sem consideração a seus conflitos
        de leis. Qualquer ação legal ou procedimento decorrente destes Termos de Uso será exclusivamente julgado nos
        tribunais competentes da jurisdição brasileira.
      </p>
    </section>

    <section id="severabilidade" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">14. Severabilidade</h2>
      <p class="mb-4">
        Se qualquer disposição destes Termos de Uso for considerada inválida ou inexequível, as disposições remanescentes
        permanecerão em pleno vigor e efeito.
      </p>
    </section>

    <section id="contato" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">15. Contato e Suporte</h2>
      <p class="mb-4">
        Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através dos canais de suporte fornecidos
        na Plataforma. Nos esforçaremos para responder à sua solicitação dentro de um prazo razoável.
      </p>
    </section>

    <div class="bg-gray-100 p-6 rounded-lg mt-12">
      <p class="text-sm text-gray-700">
        <strong>Aviso:</strong> Estes Termos de Uso são vinculativos legalmente. Leia cuidadosamente antes de usar a Plataforma.
        Se tiver dúvidas, procure orientação jurídica.
      </p>
    </div>
  </div>
</div>
